import { render, staticRenderFns } from "./assemblyTable.vue?vue&type=template&id=5c860382&scoped=true"
import script from "./assemblyTable.vue?vue&type=script&lang=js"
export * from "./assemblyTable.vue?vue&type=script&lang=js"
import style0 from "./assemblyTable.vue?vue&type=style&index=0&id=5c860382&prod&lang=scss"
import style1 from "./assemblyTable.vue?vue&type=style&index=1&id=5c860382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c860382",
  null
  
)

export default component.exports